<template>
  <div>
    <PhieuSuaChuaFormCuaHang />
  </div>
</template>

<script>
import PhieuSuaChuaFormCuaHang from "../components/organisms/PhieuSuaChuaFormCuaHang.vue";

export default {
  name: "PhieuSuaChua",
  components: { PhieuSuaChuaFormCuaHang },
  data() {
    return {};
  },

  created() {},

  methods: {},
};
</script>

<style style type="scss" media="print" scoped></style>
